import React from 'react'
import { STRINGS } from '@/app/constants/componentStrings';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import {Column} from 'primereact/column';

import DocumentImageService from '@/app/api/service/DocumentImageService';

function DocumentosContrato( {documentos} ){

    const visualizarDocContratoTemplate = (rowData) => (
        <Button type="button" onClick={ e => { e.preventDefault();  DocumentImageService.visualizarDocumento('contrato', rowData.id)} }
                icon="pi pi-download" 
                className="p-button-primary"
                style={{marginRight: '.5em'}}>
        </Button>
    )

    return(
        <DataTable value={documentos} emptyMessage={STRINGS.emptyMessage}>
            <Column field="descricaoTipoDocumento" header="Documento" />
            <Column field="nomeArquivo" header="Arquivo" />
            <Column  body={visualizarDocContratoTemplate} className="coluna-acao"/>
        </DataTable>
    )
}

export default DocumentosContrato